/**
 * Single source of truth for displaying money on this site.
 * The whole store (admin + storefront) uses Serbian Dinars (RSD) only.
 * Prices are stored as whole dinars (no decimals) everywhere in the DB.
 */
export function formatRSD(amount: number | undefined | null): string {
  const value = Math.round(Number(amount) || 0);
  return `${value.toLocaleString('sr-RS')} RSD`;
}

/** Same as formatRSD but without the "RSD" suffix, for inputs/labels that add it separately. */
export function formatRSDNumber(amount: number | undefined | null): string {
  const value = Math.round(Number(amount) || 0);
  return value.toLocaleString('sr-RS');
}
